import { render, staticRenderFns } from "./inputColorPicker.vue?vue&type=template&id=2e4e5364&scoped=true&"
import script from "./inputColorPicker.vue?vue&type=script&lang=js&"
export * from "./inputColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./inputColorPicker.vue?vue&type=style&index=0&id=2e4e5364&prod&lang=scss&"
import style1 from "./inputColorPicker.vue?vue&type=style&index=1&id=2e4e5364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e5364",
  null
  
)

export default component.exports